import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#2e3436"><path d="M7.494 4h7c.277 0 .5.223.5.5v1c0 .277-.223.5-.5.5h-7a.499.499 0 01-.5-.5v-1c0-.277.223-.5.5-.5zm0 6h7c.277 0 .5.223.5.5v1c0 .277-.223.5-.5.5h-7a.499.499 0 01-.5-.5v-1c0-.277.223-.5.5-.5z" style={{
        marker: "none"
      }} /><path d="M2.996 3h1.998v4h-2V5h-1l.002-1z" style={{
        marker: "none"
      }} color="#000" overflow="visible" /><path style={{
        lineHeight: 1.25,
        InkscapeFontSpecification: "'Cantarell Ultra-Bold'",
        fontVariantLigatures: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontFeatureSettings: "normal",
        textAlign: "start"
      }} d="M1.975 13h4.019v-1h-2c1.5-.5 1.777-1.299 1.832-1.791.089-.806-.896-1.52-1.897-1.513-.74.005-1.305.242-1.935.804l.5 1c.9-.59 1.838-1.05 1.865-.304.02.536-1.865.804-2.384 1.835z" fontWeight={800} fontFamily="Cantarell" letterSpacing={0} wordSpacing={0} /></g></svg>;
}

export default SvgComponent;